"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

require("react-dates/initialize");

var _reactDates = require("react-dates");

var _ArrowLeft = _interopRequireDefault(require("@paprika/icon/lib/ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("@paprika/icon/lib/ArrowRight"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _ShortcutPanel = _interopRequireDefault(require("./internal/ShortcutPanel"));

var _calendar = _interopRequireWildcard(require("./internal/calendar.styles"));

var types = _interopRequireWildcard(require("./types"));

var _StyledButton = (0, _styledComponents["default"])(_button["default"]).withConfig({
  displayName: "SingleDateCalendar___StyledButton",
  componentId: "wv5i0q-0"
})(["", ""], _calendar.monthHeaderButtonStyles);

var _StyledSpan = (0, _styledComponents["default"])("span").withConfig({
  displayName: "SingleDateCalendar___StyledSpan",
  componentId: "wv5i0q-1"
})(["", ""], _calendar.arrowIconStyles);

var _StyledSpan2 = (0, _styledComponents["default"])("span").withConfig({
  displayName: "SingleDateCalendar___StyledSpan2",
  componentId: "wv5i0q-2"
})(["", ""], _calendar.arrowIconStyles);

var _StyledSpan3 = (0, _styledComponents["default"])("span").withConfig({
  displayName: "SingleDateCalendar___StyledSpan3",
  componentId: "wv5i0q-3"
})(["", ""], _calendar.dayTriggerStyles);

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "SingleDateCalendar___StyledDiv",
  componentId: "wv5i0q-4"
})(["", ""], _calendar.calendarWrapperStyles);

var _StyledDiv2 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "SingleDateCalendar___StyledDiv2",
  componentId: "wv5i0q-5"
})(["", ""], _calendar["default"]);

function SingleDateCalendar(props) {
  // TODO: nice to have MIN_DATE & MAX_DATE customizable
  var MIN_DATE = _moment["default"].utc("0000-01-01", "YYYY-MM-DD");

  var MAX_DATE = _moment["default"].utc("9999-12-31", "YYYY-MM-DD");

  var I18n = (0, _useI18n["default"])(); // Props

  var date = props.date,
      onSelect = props.onSelect,
      possibleDate = props.possibleDate,
      resetPossibleDate = props.resetPossibleDate,
      kind = props.kind; // State

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      shouldShowShortcut = _React$useState2[0],
      setShouldShowShortcut = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(null),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      currentMonth = _React$useState4[0],
      setCurrentMonth = _React$useState4[1]; // Ref


  var nextButtonRef = _react["default"].useRef(null);

  var prevButtonRef = _react["default"].useRef(null);

  var calendarRef = _react["default"].useRef(null);

  function keepFocus() {
    if (calendarRef.current) calendarRef.current.focus();
  }

  _react["default"].useEffect(function () {
    keepFocus();
  }, [currentMonth, date]);

  function getInitialVisibleMonth() {
    var initialVisibleMonth;

    if (possibleDate && possibleDate.isValid()) {
      initialVisibleMonth = possibleDate;
    } else if (currentMonth && currentMonth.isValid()) {
      initialVisibleMonth = currentMonth;
    } else {
      initialVisibleMonth = date && date.isValid() ? date : (0, _moment["default"])();
    }

    return initialVisibleMonth;
  }

  function handleClickHeader(month) {
    setCurrentMonth(month);
    resetPossibleDate();
    setShouldShowShortcut(true);
  }

  function handleCancelShortcut() {
    setShouldShowShortcut(false);
    keepFocus();
  }

  function handleConfirmShortcut(_ref) {
    var month = _ref.month,
        year = _ref.year;
    setCurrentMonth(_moment["default"].utc([year, month]));
    resetPossibleDate();
    setShouldShowShortcut(false);
    keepFocus();
  }

  function handleClickNavigation(buttonRef) {
    if (buttonRef.current.parentNode.tabIndex !== 0) {
      // eslint-disable-next-line no-param-reassign
      buttonRef.current.parentNode.tabIndex = 0;
    }

    buttonRef.current.parentNode.focus();
  }

  function handleClickNextMonth() {
    handleClickNavigation(nextButtonRef);
  }

  function handleClickPrevMonth() {
    handleClickNavigation(prevButtonRef);
  }

  function isOutsideSupportedRange(day) {
    return day.isBefore(MIN_DATE, "day") || day.isAfter(MAX_DATE, "day");
  }
  /* eslint-disable react/prop-types */


  function renderMonthHeaderElement(_ref2) {
    var month = _ref2.month;
    return /*#__PURE__*/_react["default"].createElement(_StyledButton, {
      isDropdown: true,
      isSemantic: false,
      kind: _button["default"].types.kind.FLAT,
      onClick: function onClick() {
        handleClickHeader(month);
      },
      tabIndex: -1,
      "data-pka-anchor": "calendar.header"
    }, month.format(I18n.t("calendar.header_format")));
  }
  /* eslint-enable react/prop-types */


  function renderArrowLeft() {
    return /*#__PURE__*/_react["default"].createElement(_StyledSpan, {
      ref: prevButtonRef,
      "data-pka-anchor": "calendar-prev-month"
    }, /*#__PURE__*/_react["default"].createElement(_ArrowLeft["default"], {
      role: "presentation"
    }));
  }

  function renderArrowRight() {
    return /*#__PURE__*/_react["default"].createElement(_StyledSpan2, {
      ref: nextButtonRef,
      "data-pka-anchor": "calendar-next-month"
    }, /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], {
      role: "presentation"
    }));
  }

  function renderDayContents(day) {
    return /*#__PURE__*/_react["default"].createElement(_StyledSpan3, null, day.format("D"));
  }

  var CalendarKey = "".concat(currentMonth && currentMonth.format("YYYY-MM"), "/").concat(possibleDate && possibleDate.format("YYYY-MM"), "/").concat(date && date.format("YYYY-MM"));
  return /*#__PURE__*/_react["default"].createElement(_StyledDiv, {
    tabIndex: -1,
    ref: calendarRef
  }, /*#__PURE__*/_react["default"].createElement(_StyledDiv2, {
    isVisible: !shouldShowShortcut,
    kind: kind
  }, /*#__PURE__*/_react["default"].createElement(_reactDates.DayPickerSingleDateController, {
    key: CalendarKey,
    date: date,
    onDateChange: onSelect,
    focused: true,
    isOutsideRange: isOutsideSupportedRange,
    renderMonthElement: renderMonthHeaderElement,
    enableOutsideDays: true,
    numberOfMonths: 1,
    initialVisibleMonth: getInitialVisibleMonth,
    hideKeyboardShortcutsPanel: true,
    noBorder: kind === SingleDateCalendar.types.kind.EMBEDDED,
    daySize: 34,
    verticalBorderSpacing: 0,
    transitionDuration: 0,
    horizontalMonthPadding: 0,
    navPrev: renderArrowLeft(),
    navNext: renderArrowRight(),
    onPrevMonthClick: handleClickPrevMonth,
    onNextMonthClick: handleClickNextMonth,
    renderDayContents: renderDayContents
  })), /*#__PURE__*/_react["default"].createElement(_ShortcutPanel["default"], {
    key: shouldShowShortcut,
    date: currentMonth || (0, _moment["default"])(),
    isVisible: shouldShowShortcut,
    onCancel: handleCancelShortcut,
    onConfirm: handleConfirmShortcut
  }));
}

SingleDateCalendar.types = {
  kind: types.kind
};
var propTypes = {
  /** Selected date in moment object */
  date: _propTypes["default"].instanceOf(_moment["default"]),

  /** Callback when user select date */
  onSelect: _propTypes["default"].func.isRequired,

  /** Possible date might be selected in moment object */
  possibleDate: _propTypes["default"].instanceOf(_moment["default"]),
  resetPossibleDate: _propTypes["default"].func,

  /** Kind of styling */
  kind: _propTypes["default"].oneOf((0, _values["default"])(SingleDateCalendar.types.kind))
};

var noop = function noop() {};

var defaultProps = {
  date: null,
  possibleDate: null,
  resetPossibleDate: noop,
  kind: SingleDateCalendar.types.kind.BORDERED
};
SingleDateCalendar.propTypes = propTypes;
SingleDateCalendar.defaultProps = defaultProps;
var _default = SingleDateCalendar;
exports["default"] = _default;
//# sourceMappingURL=SingleDateCalendar.js.map